import { sparklinePath } from "../sparkline";

/**
 * A tiny inline-SVG trend line. Neutral by default (inherits `currentColor` = iron); it's a shape,
 * not a mark — the kintsugi rule stays intact (no colour unless a caller wraps it in .gold/.err).
 */
export function Sparkline({
  values,
  w = 104,
  h = 26,
  className,
}: {
  values: number[];
  w?: number;
  h?: number;
  className?: string;
}) {
  const d = sparklinePath(values, w, h);
  return (
    <svg
      width={w}
      height={h}
      viewBox={`0 0 ${w} ${h}`}
      className={className}
      preserveAspectRatio="none"
      aria-hidden="true"
      style={{ display: "block", overflow: "visible" }}
    >
      <path d={d} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  );
}
